import { createBlueprint as t } from "@made-people/blueprint";
const r = t({
  slots: {
    wrapper: "p-2 md:p-4 lg:p-6 bg-neutral-50 flex justify-center gap-2",
    item: "flex-1 flex flex-col items-center justify-start gap-2",
    icon: "w-5 h-5 flex justify-center items-center md:w-6 md:h-6 lg:w-8 lg:h-8",
    text: "text-body-xs md:text-body-sm text-center",
    textLabel: "font-bold",
    textDescription: ""
  },
  variants: {}
});
export {
  r as featureGroupBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
